import { render, staticRenderFns } from "./StcvPD_ItemsFinish.vue?vue&type=template&id=2efbeda2"
import script from "./StcvPD_ItemsFinish.vue?vue&type=script&lang=js"
export * from "./StcvPD_ItemsFinish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports